var Order = /** @class */ (function () {
    function Order(obj, id) {
        if (id) {
            this.id = id;
        }
        this.erp_document_state = statusMapper('erp_document_state', obj.erp_document_state);
        this.number = obj.number;
        this.email = obj.email;
        this.completed_at = obj.completed_at;
        this.total = obj.total;
        this.payment_method_name = obj.payment_method_name;
        this.delivery_method_name = obj.delivery_method_name;
        this.assigned_to_operator = obj.assigned_to_operator || false;
    }
    Object.defineProperty(Order.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "Number", {
        // Status mapper
        get: function () {
            return this.number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "Email", {
        get: function () {
            return this.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "ErpDocumentState", {
        get: function () {
            return this.erp_document_state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "CompletedAt", {
        get: function () {
            return this.completed_at;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "Total", {
        get: function () {
            return this.total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "PaymentMethodName", {
        get: function () {
            return this.payment_method_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "DeliveryMethodName", {
        get: function () {
            return this.delivery_method_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Order.prototype, "assigned", {
        get: function () {
            return this.assigned_to_operator ? "Да" : "Не";
        },
        enumerable: false,
        configurable: true
    });
    return Order;
}());
export { Order };
export function createOrder(obj, id) {
    return new Order(obj, id);
}
export function statusMapper(type, obj) {
    if (type === 'erp_document_state') {
        if (obj === 'erp_document_new') {
            return 'Нов';
        }
        if (obj === 'erp_document_completed') {
            return 'Завършен';
        }
        if (obj === 'erp_document_firm_planned') {
            return 'Потвърден';
        }
        if (obj === 'erp_document_released') {
            return 'Пуснат';
        }
        if (obj === 'erp_document_void') {
            return 'Анулиран';
        }
        return 'Друг';
    }
    if (type === 'erp_status') {
        if (obj === 'erp_error') {
            return 'Грешка';
        }
        if (obj === 'erp_success') {
            return 'Успешно';
        }
        if (obj === 'erp_processing') {
            return 'В процес';
        }
    }
}
export function createOrders(rawOrders) {
    var orders = [];
    var rawOrdersData = rawOrders.data;
    for (var _i = 0, rawOrdersData_1 = rawOrdersData; _i < rawOrdersData_1.length; _i++) {
        var rawOrder = rawOrdersData_1[_i];
        var order = createOrder(rawOrder.attributes, rawOrder.id);
        orders.push(order);
    }
    return orders;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/order/order.ts
// module id = 65
// module chunks = 0